import a from"./stateManager.js";var e=a.getInstance();export{e as TokenManager,e as default};
//# sourceMappingURL=tokenManager.js.map